import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/fe-toolbox'

import useSearchQuery from 'app/SearchPage/hooks/useSearchQuery'
import useSETrackEvent from 'app/SearchPage/hooks/useSETrackEvent'

const useBackButton = () => {
  const router = useRouter()
  const { searchQueryFromURL } = useSearchQuery()
  const { SETrackSearchPage } = useSETrackEvent()

  const onClickBackWebFallback = () => {
    SETrackSearchPage('CLICK_BACK_BUTTON', { text_input: searchQueryFromURL })

    if (window.history.length <= 2) router.push('/home')
    else router.back()
  }

  const onClickBack = () => {
    historyUtils.backToApp(onClickBackWebFallback)
  }

  return {
    onClickBack,
  }
}

export default useBackButton
